import { token } from '@atlaskit/tokens';

export const ProgressCircle = ({ percentage }: { percentage: number }) => {
  const radius = 7;
  const viewBoxSize = 16;
  const getStrokeDashArray = (): string => {
    const circleCircumference = 2 * Math.PI * radius;
    const filledPercentage = percentage * circleCircumference;
    return `${filledPercentage} ${circleCircumference}`;
  };
  const strokeColor =
    percentage <= 1 ? token('color.text.success') : token('color.text.danger');
  return (
    <svg
      width={viewBoxSize}
      height={viewBoxSize}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
    >
      <g>
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          stroke={`${token('color.border')}`}
          strokeWidth="2"
          fill="transparent"
        />
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          stroke={`${strokeColor}`}
          strokeWidth="2"
          fill="transparent"
          strokeDasharray={getStrokeDashArray()}
          transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
        />
      </g>
    </svg>
  );
};
